import React from "react";

export const CircularProgress = ({
  percent = 0,
  size = 50,
  stroke = 3,
  positionStyles = {},
  title,
}) => {
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percent / 100) * circumference;

  // Dynamically choose color
  const progressColor = percent === 100 ? "#4caf50" : "#2196f3";

  return (
    <div className="position-absolute" title={title} style={positionStyles}>
      <svg width={size} height={size}>
        {/* Background Circle */}
        <circle
          stroke="#eee"
          fill="none"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={stroke}
        />
        {/* Progress Circle with dynamic color */}
        <circle
          stroke={progressColor}
          fill="none"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={stroke}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{
            transform: `rotate(-90deg)`,
            transformOrigin: "50% 50%",
            transition: "stroke-dashoffset 0.5s ease, stroke 0.3s ease",
          }}
        />
        {/* Percentage Text */}
        <text
          x="50%"
          y="53%"
          dominantBaseline="middle"
          textAnchor="middle"
          fontSize="12"
          fill="#333"
          fontWeight={600}
        >
          {percent ? percent : 0}%
        </text>
      </svg>
    </div>
  );
};
